module.exports = __webpack_public_path__ + "img/서브5_패스킥슛.941207d2.svg";